<form class="m-t-20" [formGroup]="form" (submit)="submit()">
  <div class="form-group">
    <label>
      <textarea class="form-control" [maxLength]="150" rows="3" name="notes" formControlName="notes" [placeholder]="'...'"></textarea>
    </label>
  </div>

  <div class="actions">
    <button class="btn btn-outline-primary" (click)="cancel()">{{ 'cart.modalSeeNotes.cancel' | cxTranslate }}</button>
    <button type="submit" class="btn btn-primary">{{ 'cart.modalSeeNotes.save' | cxTranslate }}</button>
  </div>
</form>